// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIsMobile } from '@tectonics/hooks';

import { HighlightBox } from '../../../../atoms';

import { PixTicketAmount } from './pix-ticket-amount';
import { PixTicketExpiration } from './pix-ticket-expiration';
import { QrCodeDesktop } from './qr-code-desktop';
import { QrCodeMobile } from './qr-code-mobile';

export function Ticket(): Node {
  const isMobile = useIsMobile();
  const QrCode = isMobile ? QrCodeMobile : QrCodeDesktop;

  return (
    <Grid>
      <GridSlot name="amount">
        <PixTicketAmount />
      </GridSlot>
      <GridSlot name="expiration">
        <PixTicketExpiration />
      </GridSlot>
      <GridSlot name="code">
        <QrCode />
      </GridSlot>
    </Grid>
  );
}

const GridSlot = styled(HighlightBox)`
  grid-area: ${props => props.name};
`;

const Grid = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-areas: "amount expiration"
                       "code code";
  ${GridSlot} {
    border-style: none;
    border-radius: 0;
    &:nth-child(1) {
      border-top-left-radius: 5px;
      border-style: solid none none solid;
    }
    &:nth-child(2) {
      border-top-right-radius: 5px;
      border-style: solid solid none solid;
    }
    &:nth-child(3) {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      border-style: solid;
    }
  }
`;
